import React, { useEffect } from "react";
export default function PdfPopup({ isOpen, onClose, pdfUrl, pages = [], title }) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isOpen || !pdfUrl) return null;
  const viewerUrl = `${pdfUrl}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`;

  return (
    <div className="pdf-popup" role="dialog" aria-modal="true" aria-label={title}>
      <button  type="button" className="pdf-popup-backdrop" aria-label="Close PDF"
        onClick={onClose}/>
      <div className="pdf-popup-dialog">
        <button  type="button" className="pdf-popup-close"
            aria-label="Close PDF" onClick={onClose}> 
           <i className="fa-solid fa-xmark" aria-hidden="true" />
        </button>
        <div className="pdf-popup-scroll">
          {pages.length > 0 ? (
            <div className="pdf-popup-pages">
              {pages.map((page, index) => (
                <img key={page} src={page}  alt={`${title} — page ${index + 1}`}
                  className="pdf-popup-page"/>
              ))}
            </div>
          ) : (
            <iframe src={viewerUrl} title={title} className="pdf-popup-frame"
              scrolling="yes"/>)}
        </div>
      </div>
    </div>
  );
}
